
import { defineComponent, ref, onMounted, onBeforeUnmount } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useApiWithAuth } from "../../modules/api";
import { TURNSTILE_VERIFIED } from "../../modules/auth";

export default defineComponent({
  setup() {
    const router = useRouter();
    const route = useRoute();
    const turnstileRef = ref<HTMLElement>();
    const verificando = ref(false);
    let widgetId: string | undefined;

    const verificar = (token: string) => {
      if (verificando.value) return;
      verificando.value = true;
      const { post } = useApiWithAuth();
      post("/verificacao", { turnstileToken: token })
        .then(() => {
          sessionStorage.setItem(TURNSTILE_VERIFIED, "true");
          const redirect = route.query.redirect as string;
          router.push(redirect || { name: "home" });
        })
        .catch(() => {
          verificando.value = false;
        });
    };

    const renderTurnstile = () => {
      if (window.turnstile && turnstileRef.value) {
        widgetId = window.turnstile.render(turnstileRef.value, {
          sitekey: "0x4AAAAAAC21H5ax1d8XlZhC",
          callback: (token: string) => {
            verificar(token);
          }
        });
      }
    };

    onMounted(() => {
      const interval = setInterval(() => {
        if (window.turnstile?.render) {
          clearInterval(interval);
          renderTurnstile();
        }
      }, 200);
      setTimeout(() => clearInterval(interval), 10000);
    });

    onBeforeUnmount(() => {
      if (widgetId && window.turnstile) {
        window.turnstile.remove(widgetId);
      }
    });

    return {
      turnstileRef
    };
  },
  components: {}
});
